import { ref } from 'vue'

export const unreadNotifications = ref(false)
